export let w: any = window
